/**
 * Get the dynamic base path from the HTML <base> tag
 * This is used to support hosting the app at different paths without rebuilding
 */
export const getBasePath = () => {
  const base = document.querySelector('base');
  if (!base) return '';

  const href = base.getAttribute('href');
  if (!href || href === '/') return '';

  // Convert the base href to a path for React Router
  // Remove trailing slash and leading protocol/domain if present
  const url = new URL(href, window.location.origin);
  const pathname = url.pathname;

  // Remove trailing slash for React Router basename
  return pathname.endsWith('/') ? pathname.slice(0, -1) : pathname;
};
